import { createTheme } from '@mui/material/styles';

import { components } from '@/config/theme/components.ts';
import {
  KnowMeTypography,
  KnowMeTypographyOverrides,
  typography,
} from '@/config/theme/typography.ts';

import { lightThemeColors, themeColors, ThemeColorSet } from './themeColors.ts';

declare module '@mui/material/styles' {
  interface Theme {
    colors: ThemeColorSet;
  }

  interface ThemeOptions {
    colors: Partial<ThemeColorSet>;
  }
}

declare module '@mui/material/styles' {
  interface TypographyVariants extends KnowMeTypography {}

  interface TypographyVariantsOptions extends Partial<KnowMeTypography> {}
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides extends KnowMeTypographyOverrides {}
}

export const createKnowMeTheme = (mode: 'dark' | 'light' = 'dark') => {
  const colors = mode === 'dark' ? themeColors : lightThemeColors;
  return createTheme({
    colors,
    components,
    palette: {
      background: {
        default: colors.bg,
        paper: colors.bgCard,
      },
      error: {
        main: colors.red,
      },
      mode,
      primary: {
        main: colors.accent,
      },
      secondary: {
        main: colors.bgCard3,
      },
      success: {
        main: colors.green,
      },
      text: {
        primary: colors.textPrimary,
        secondary: colors.textSecondary,
      },
    },
    typography: {
      fontFamily: 'General Sans, sans-serif',
      ...typography,
    },
  });
};
